import script from "./AdministratorProjectShowcase.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorProjectShowcase.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorProjectShowcase.vue?vue&type=style&index=0&id=0d472886&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d472886"]])

export default __exports__